export default "/images/0156928923c64587f057b55db55840d2.avif";